/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/SendTo/InApp/Content",
  isSubmitting,
  onChange
  
}) {
let emailsValueData = fromData.useDataValue({ viewPath,
context: 'emails',
})
let messageComposeEmailValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'email',
})
let messageComposeEmailChangeData = fromData.useDataChange({ viewPath,
context: 'message_compose',
path: 'email',
})
let messageComposeEmailIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={250}
 marginTop={0}
 marginLeft={8}
 size="small"
 data="emails"
 from={emailsValueData}
 data="message_compose.email"
 disabled={messageComposeEmailIsSubmittingData}
 value={messageComposeEmailValueData}
 onChange={messageComposeEmailChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Send to:"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
 allowEmptyChoice={false}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}